/** 与 atomic `color-L` 一致 */
const HINT_GRAY = '#A2A7AD';
const HINT_FONT = '16px PingFang SC, Source Han Sans, Helvetica, Arial, sans-serif';

/** 清空画板为白底 */
export const fillSignatureBoard = (ctx: CanvasRenderingContext2D, cssWidth: number, cssHeight: number) => {
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, cssWidth, cssHeight);
};

/**
 * 在画板中心画占位文案。画板本身不旋转，这里 rotate(90deg) 与操作层同向，
 * 横屏握持时是一行完整横排，不会拆成单字竖排。
 */
export const paintSignatureHint = (
  ctx: CanvasRenderingContext2D,
  cssWidth: number,
  cssHeight: number,
  text: string,
) => {
  ctx.save();
  ctx.translate(cssWidth / 2, cssHeight / 2);
  ctx.rotate(Math.PI / 2);
  ctx.font = HINT_FONT;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillStyle = HINT_GRAY;
  ctx.fillText(text, 0, 0);
  ctx.restore();
};
